import React from 'react';
import PropTypes from 'prop-types';
import { useResponsive } from 'hooks';
// Components
import { TopBar, Footer, Drawer } from './components';

const Main = (props) => {
  const { children } = props;
  const { isDesktop } = useResponsive();
  const [drawerState, setDrawerState] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setDrawerState(open);
  };

  return (
    <div style={{ paddingTop: '72px' }}>
      <TopBar menuClick={toggleDrawer(true)} />
      {!isDesktop && <Drawer open={drawerState} onClose={toggleDrawer(false)} />}
      <main style={{ minHeight: 'calc(100vh - 72px)' }}>{children}</main>
      <Footer />
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node,
};

export default Main;
